<template>
  <div>
    <v-card>
      <v-toolbar color="primary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('internal') }}</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form">
        <v-card-text>
          <v-textarea class="mb-6"
                      filled
                      hide-details="auto"
                      v-bind:label="$t('notes')"
                      v-model="spot.notes" />
        </v-card-text>
      </v-form>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {

    computed: {
           rules() {
        return {
          required: v => !!v || this.$t('global.pleaseFillOutThisField')
        }
      },
      ...mapGetters({
      })
    },
    name: 'SpotInternalDetailsCard',
    methods: {
      validate() {
        return this.$refs.form.validate()
      }
    },
    props: {
      spot: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "internal": "Intern",
      "notes": "Notizen"
    },
    "en": {
      "internal": "Internal",
      "notes": "Notes"
    }
  }
</i18n>